// extracted by mini-css-extract-plugin
module.exports = {"ReplyButton":"pl_a bgu_vr bgu_iv bgu_wf bgu_i bgu_j bgu_q bgu_un bgu_en bgu_ri bgu_rj bgu_cx","ReplyButton__icon":"pl_b bgu_re"};